var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect3, _path13, _path14, _path15, _path16, _path17, _rect4, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavedProductsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 406,
    viewBox: "0 0 302 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 81,
    y: 74,
    width: 124,
    height: 234,
    fill: "#CBA67A",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M239.205 155.649C229.814 137.864 217.498 127.787 201.361 125.048C172.45 120.142 156.256 131.628 136.562 133.074C116.869 134.519 106.17 122.562 88.6218 117.213C74.9246 113.038 47.4821 120.717 38.6122 139.223C29.9429 157.497 21.8812 174.37 33.8459 198.097C45.5783 221.623 66.3234 228.592 80.067 252.841C93.8106 277.091 96.1387 300.162 113.011 309.914C130.703 320.139 171.402 323.421 192.931 301.967C210.248 284.711 206.555 257.863 221.933 239.097C237.311 220.331 244.018 211.549 245.159 199.362C246.736 182.515 246.878 170.182 239.205 155.649Z",
    stroke: "#363432",
    strokeOpacity: 0.24,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 240,
    width: 120,
    height: 166,
    fill: "#E9D7C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.75 318.5H238.25V315.5C238.25 315.301 238.171 315.11 238.03 314.97C237.89 314.829 237.699 314.75 237.5 314.75H234.5C234.301 314.75 234.11 314.829 233.97 314.97C233.829 315.11 233.75 315.301 233.75 315.5V318.5Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.25 327.5H242.75V315.5C242.75 315.301 242.671 315.11 242.53 314.97C242.39 314.829 242.199 314.75 242 314.75H239C238.801 314.75 238.61 314.829 238.47 314.97C238.329 315.11 238.25 315.301 238.25 315.5V327.5Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.047 327.8L250.397 326.628L251.175 329.525C251.2 329.621 251.207 329.72 251.194 329.818C251.181 329.916 251.148 330.01 251.099 330.096C251.049 330.181 250.983 330.256 250.904 330.316C250.826 330.375 250.736 330.419 250.641 330.444L247.744 331.222C247.552 331.274 247.348 331.248 247.176 331.149C247.004 331.051 246.878 330.888 246.825 330.697L246.047 327.8Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.723 319.099L248.073 317.937L247.295 315.04C247.242 314.849 247.117 314.685 246.945 314.585C246.773 314.485 246.569 314.457 246.376 314.506L243.48 315.284C243.288 315.337 243.125 315.462 243.025 315.634C242.925 315.806 242.896 316.01 242.945 316.203L243.723 319.099Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 314.75H234.5C234.086 314.75 233.75 315.086 233.75 315.5V330.5C233.75 330.914 234.086 331.25 234.5 331.25H237.5C237.914 331.25 238.25 330.914 238.25 330.5V315.5C238.25 315.086 237.914 314.75 237.5 314.75Z",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.75 318.5H238.25",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242 314.75H239C238.586 314.75 238.25 315.086 238.25 315.5V330.5C238.25 330.914 238.586 331.25 239 331.25H242C242.414 331.25 242.75 330.914 242.75 330.5V315.5C242.75 315.086 242.414 314.75 242 314.75Z",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.25 327.5H242.75",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M246.372 314.51L243.474 315.286C243.074 315.394 242.837 315.805 242.944 316.205L246.826 330.694C246.934 331.094 247.345 331.331 247.745 331.224L250.643 330.448C251.043 330.34 251.28 329.929 251.173 329.529L247.291 315.04C247.184 314.64 246.772 314.403 246.372 314.51Z",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.047 327.8L250.397 326.628",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.727 319.1L248.077 317.938",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 190,
    width: 120,
    height: 166,
    fill: "#E9D7C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66 272.25H68.5406C68.679 272.25 68.8148 272.212 68.9324 272.139C69.0501 272.066 69.1449 271.962 69.2062 271.837L70.9313 268.388C71.0167 268.215 71.0333 268.016 70.9776 267.831C70.9218 267.647 70.798 267.49 70.6312 267.394L66 264.75",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0022 272.25H51.4615C51.3231 272.25 51.1874 272.212 51.0697 272.139C50.9521 272.066 50.8572 271.962 50.7959 271.837L49.0709 268.388C48.9854 268.215 48.9689 268.016 49.0246 267.831C49.0803 267.647 49.2041 267.49 49.3709 267.394L54.0022 264.75",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66 272.25H68.5406C68.679 272.25 68.8148 272.212 68.9324 272.139C69.0501 272.066 69.1449 271.962 69.2062 271.837L70.9313 268.388C71.0167 268.215 71.0333 268.016 70.9776 267.831C70.9218 267.647 70.798 267.49 70.6312 267.394L66 264.75V272.25Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0022 272.25H51.4615C51.3231 272.25 51.1874 272.212 51.0697 272.139C50.9521 272.066 50.8572 271.962 50.7959 271.837L49.0709 268.388C48.9854 268.215 48.9689 268.016 49.0246 267.831C49.0803 267.647 49.2041 267.49 49.3709 267.394L54.0022 264.75V272.25Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63 264.75C63 265.546 62.6839 266.309 62.1213 266.871C61.5587 267.434 60.7956 267.75 60 267.75C59.2044 267.75 58.4413 267.434 57.8787 266.871C57.3161 266.309 57 265.546 57 264.75H54V280.5C54 280.699 54.079 280.89 54.2197 281.03C54.3603 281.171 54.5511 281.25 54.75 281.25H65.25C65.4489 281.25 65.6397 281.171 65.7803 281.03C65.921 280.89 66 280.699 66 280.5V264.75H63Z",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    width: 120,
    height: 166,
    fill: "#E9D7C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M210.5 86V89.75C210.5 89.9489 210.421 90.1397 210.28 90.2803C210.14 90.421 209.949 90.5 209.75 90.5H196.25C196.051 90.5 195.86 90.421 195.72 90.2803C195.579 90.1397 195.5 89.9489 195.5 89.75V86C194.704 86 193.941 85.6839 193.379 85.1213C192.816 84.5587 192.5 83.7956 192.5 83C192.5 82.2044 192.816 81.4413 193.379 80.8787C193.941 80.3161 194.704 80 195.5 80V77.75C195.5 76.9544 195.816 76.1913 196.379 75.6287C196.941 75.0661 197.704 74.75 198.5 74.75H207.5C208.296 74.75 209.059 75.0661 209.621 75.6287C210.184 76.1913 210.5 76.9544 210.5 77.75V80C211.296 80 212.059 80.3161 212.621 80.8787C213.184 81.4413 213.5 82.2044 213.5 83C213.5 83.7956 213.184 84.5587 212.621 85.1213C212.059 85.6839 211.296 86 210.5 86Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 83.75H207.5",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 80V77.75C195.5 76.9544 195.816 76.1913 196.379 75.6287C196.941 75.0661 197.704 74.75 198.5 74.75H207.5C208.296 74.75 209.059 75.0661 209.621 75.6287C210.184 76.1913 210.5 76.9544 210.5 77.75V80",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 86.75V83C198.5 82.4067 198.324 81.8266 197.994 81.3333C197.665 80.8399 197.196 80.4554 196.648 80.2284C196.1 80.0013 195.497 79.9419 194.915 80.0576C194.333 80.1734 193.798 80.4591 193.379 80.8787C192.959 81.2982 192.673 81.8328 192.558 82.4147C192.442 82.9967 192.501 83.5999 192.728 84.1481C192.955 84.6962 193.34 85.1648 193.833 85.4944C194.327 85.8241 194.907 86 195.5 86V89.75C195.5 89.9489 195.579 90.1397 195.72 90.2803C195.86 90.421 196.051 90.5 196.25 90.5H209.75C209.949 90.5 210.14 90.421 210.28 90.2803C210.421 90.1397 210.5 89.9489 210.5 89.75V86C211.093 86 211.673 85.8241 212.167 85.4944C212.66 85.1648 213.045 84.6962 213.272 84.1481C213.499 83.5999 213.558 82.9967 213.442 82.4147C213.327 81.8328 213.041 81.2982 212.621 80.8787C212.202 80.4591 211.667 80.1734 211.085 80.0576C210.503 79.9419 209.9 80.0013 209.352 80.2284C208.804 80.4554 208.335 80.8399 208.006 81.3333C207.676 81.8266 207.5 82.4067 207.5 83V86.75",
    stroke: "#90734F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedProductsPlaceholder);
export default __webpack_public_path__ + "static/media/saved-products-placeholder.97f424fe34dfe5ce319e50d85137e1d1.svg";
export { ForwardRef as ReactComponent };